import type { PlainErrorObject } from "./types";

/**
 * Error objects are not enumerable and cannot be stringified. This function converts Errors to
 * plain objects.
 */
function convertErrorForLogging(error: unknown): PlainErrorObject | unknown {
  if (error instanceof Error) {
    return {
      message: error.message,
      name: error.name,
      stack: error.stack,
    };
  }

  return error;
}

export { convertErrorForLogging };
